import ProductFile from './ProductFile';

export default ProductFile;


// WEBPACK FOOTER //
// ./src/components/ProductFile/index.tsx